import React, { useCallback, useEffect, useState } from 'react';
// eslint-disable-next-line max-len
import { Person } from '@sdir/httpclient/lib/clients/core/search';
import { useAuthenticatedCheck, useCurrentUser } from '@sdir/auth/lib/hooks';
import { Loadable } from '../../../types';
import { commonAddresseePersonApi, personApi } from '../../../httpclient';
import {
  CurrentPersonContext,
  ICurrentPersonContext,
} from '../../../services/contexts/CurrentPersonContext';
import { useCurrentUserInfo } from '../../../services/hooks/useCurrentUserInfo';

export const CurrentPersonProvider: React.FC<{ children: any }> = ({ children }) => {
  const { isAuthenticated } = useAuthenticatedCheck(false);

  const {
    userInfo: { isOrganization, isExternal },
  } = useCurrentUserInfo();

  const currentUser = useCurrentUser();

  const [currentPerson, setPerson] = useState<Loadable<Person>>({});

  const loadPerson = useCallback(async () => {
    setPerson({ loading: true });
    if (isExternal && currentUser?.profile) {
      commonAddresseePersonApi
        .v1PersonGetpersonbyusernameUsernameGet(currentUser?.profile?.name || '')
        .then((response) => {
          const person = response?.data;
          if (!person) {
            throw new Error('Correct user could not be found');
          }
          setPerson({
            result: {
              firstName: person?.firstname,
              lastName: person?.lastname,
              middleName: person?.middlename,
              email: person?.username,
              commonAddresseeId: person?.commonAddresseeId,
              dateOfBirth: person?.birthDate,
              legalEntityId: person?.legalEntityId,
              personalIdentificationNumber: person?.personalIdentityNumber,
            } as Person,
          });
        })
        .catch((error) => {
          setPerson({ error });
        });
    } else {
      personApi
        .v1PersonGetownpersonbycurrentuserGet()
        .then((response) => {
          if (response.data.source?.length !== 1) {
            throw new Error('Correct user could not be found');
          }
          setPerson({ result: response.data.source[0] });
        })
        .catch((error) => {
          setPerson({ error });
        });
    }
  }, [isExternal, currentUser?.profile]);

  useEffect(() => {
    if (isAuthenticated && !isOrganization) {
      loadPerson();
    }
  }, [isAuthenticated, isExternal, isOrganization]);

  const value: ICurrentPersonContext = {
    person: currentPerson,
    refresh: loadPerson,
  };

  return <CurrentPersonContext.Provider value={value}>{children}</CurrentPersonContext.Provider>;
};
